import { render, staticRenderFns } from "./AddContact.vue?vue&type=template&id=2d60c6db&scoped=true"
import script from "./AddContact.vue?vue&type=script&lang=js"
export * from "./AddContact.vue?vue&type=script&lang=js"
import style0 from "./AddContact.vue?vue&type=style&index=0&id=2d60c6db&prod&lang=scss&scoped=true"
import style1 from "./AddContact.vue?vue&type=style&index=1&id=2d60c6db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d60c6db",
  null
  
)

export default component.exports